import { defineStore } from 'pinia'
import  axios  from "axios";

export const useSettingsStore = defineStore('fpe-settings', {

    state: () => ({
        settings: fpe.settings,
        isUpdating: false,
        nonce: fpe.security,
        ajax_url: fpe.ajax_url,
    }),
    actions: {
        updateSettings(data){
            this.isUpdating = true;
            
            const { ajax_url, security } = fpe;
            axios.post(`${ajax_url}?action=fpe_settings&fpe_nonce=${security}`, {
                settings: this.settings,
                action: 'fpe_settings_update'
            })
            .then( function (response) {
                if(response.data.success){
                    window.location.reload();
                }
            })
            .catch(function (error){
                this.isUpdating = false;
            })
        }
    }
});

